var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-button',{staticClass:"btn-circle btn-lg text-white button animated--grow-in",class:_vm.bg,attrs:{"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('statusChange', _vm.actionStatus)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }